import { Link, Stack } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import type { PlatformPoliciesRow } from "../../hooks/usePlatformPoliciesTableData";
import { policyIcon } from "~/pages/inventory/utils/policyIcon";
import { Link as RouterLink } from "react-router-dom";

export const PlatformPoliciesTableNameCell: GridColDef<PlatformPoliciesRow>["renderCell"] =
  ({ row }) => {
    return (
      <Stack direction="row" gap={2} alignItems="center">
        {policyIcon(row.name, "small")}
        <Link
          component={RouterLink}
          to={`/policies/${row.encodedId}`}
          sx={{
            color: "text.primary",
            ":hover": {
              color: "primary.light",
              textDecoration: "underline",
            },
          }}
        >
          {row.name}
        </Link>
      </Stack>
    );
  };
